import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DecimalPipe, NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-buy',
  standalone: true,
  imports: [RouterLink, NgFor, NgIf, DecimalPipe],
  templateUrl: './buy.component.html',
  styleUrls: ['./buy.component.css']
})
export class BuyComponent {
  basePrice = 24.9;
  shippingPrice = 3.9;
  soldOut = true;

  get total(): number {
    return this.basePrice + this.shippingPrice;
  }

  perks = [
    'Edición en color lista para mesa o viajes',
    'Cartas de personaje, arma, lugar y objetivo listas para barajar',
    'Reglamento en papel para consultar rápido'
  ];
}
